import {IController, IScope} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";

export class planningRoutesQueryTableRowCtrl implements IController {
  planningRoutesTableCtrl: IController;
  routeId: any;
  isSelected: any;
  show: any;
  highlighted: any;
  onToggle: any;
  columns: any;
  hasFleetManagementPermission: boolean;
  onResetRoute: Function;

  public route: any;
  public deliveriesRef: any;

  constructor(private $planningRoutes, private deliveriesService: DeliveriesService, private leanPlanningConstants,
              private $deliveries, private $scope: IScope) {
    this.deliveriesRef = this.$deliveries();
  }


  $onInit() {
    if (this.routeId) {
      this.$planningRoutes(this.routeId).$bindCtrlToId(this.$scope, this, 'route', 'routeId');
    }
  };

  $onChanges(changes) {
    if (changes.routeId && !changes.routeId.isFirstChange()) {
      this.$onInit();
    }
  };

  handleUnpackedDeliveries(route) {
    this.deliveriesRef.$asyncValues(route.serviceIdList)
      .then((services) => {
        let unpackedDeliveries = [];
        _.forEach(services, (service) => {
          var isUnpacked = this.deliveriesService.isDeliveryUnpacked(service.packageList[0].items);
          if (isUnpacked) {
            unpackedDeliveries.push(service);
          }
        });
        this.planningRoutesTableCtrl.onHandleUnpackedDeliveries({route: route, deliveries: unpackedDeliveries})
      })
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutesQueryTableRow', {
    require: {
      planningRoutesTableCtrl: '^planningRoutesQueryTable'
    },
    bindings: {
      routeId: '<',
      isSelected: '<',
      show: '<',
      highlighted: '<',
      columns: '<',
      hasFleetManagementPermission: '<?',
      onToggle: '&',
      onResetRoute: '&'
    },
    template: require('./planning-routes-query-table-row.html').default,
    controller: planningRoutesQueryTableRowCtrl
  });
